var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVect3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 7,
    viewBox: "0 0 23 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0005 3.5C17.0005 5.0125 18.238 6.25 19.7505 6.25C21.263 6.25 22.5005 5.0125 22.5005 3.5C22.5005 1.9875 21.263 0.75 19.7505 0.75C18.238 0.75 17.0005 1.9875 17.0005 3.5ZM14.2505 3.5C14.2505 1.9875 13.013 0.75 11.5005 0.75C9.98799 0.749999 8.75049 1.9875 8.75049 3.5C8.75049 5.0125 9.98799 6.25 11.5005 6.25C13.013 6.25 14.2505 5.0125 14.2505 3.5ZM6.00049 3.5C6.00049 1.9875 4.76299 0.749999 3.25049 0.749999C1.73799 0.749999 0.500488 1.9875 0.500488 3.5C0.500488 5.0125 1.73799 6.25 3.25049 6.25C4.76299 6.25 6.00049 5.0125 6.00049 3.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVect3);
export default __webpack_public_path__ + "static/media/vect3.d633c0c2e93c29d854342dfd0e5f1ed7.svg";
export { ForwardRef as ReactComponent };